<template>
  <div
    class="tabs-content-template tabscctmp"
    :style="tabItem.style || ''"
  >
    <div
      v-if="!mobile"
      class="tabscctmp_left"
    >
      <SimpleTabs
        :value="l_tab"
        :options="sections"
        class="tabs-column"
        style="
          --height-tab: 3.25rem;
          --tab-radius: 0;
          --clr-line-hover: transparent;
          --clr-line-active: transparent;
          --grid-gap: 0rem;
          --clr-active-text: var(--clr-primary);
          --text-transform: none;
          --clr-line: transparent;
        "
        @input="handleTabChange"
      >
        <template #default="{ item }">
          <slot :name="`tab_${item.id}`"></slot>
          <slot
            name="tab"
            :item="item"
          >
            <i
              v-if="item.icon"
              :class="item.icon"
              class="mdi text-large mr-3 ml-1"
            ></i>
            <span
              class="mr-1 truncate"
              :title="item.title"
            >
              {{ item.title }}
            </span>
          </slot>
        </template>
      </SimpleTabs>
    </div>
    <slot name="before"></slot>

    <div class="tabscctmp_right small-scroll-track">
      <div
        v-for="(item, index) in sections"
        v-show="mobile || l_tab === item.id"
        :key="index"
        :style="item.cssStyle || ''"
        class="tabscctmp_right_item-container"
      >
        <div class="tabscctmp_right_item_title">
          <slot :name="`title_${item.id}`">
            <i
              v-if="item.icon"
              :class="item.icon"
              class="mdi text-large mr-2"
            ></i>
            {{ item.title }}
          </slot>
        </div>
        <div class="tabscctmp_right_item_content small-scroll-track">
          <slot :name="`content_${item.id}`">
            {{ `content_${item.id}` }}
          </slot>
        </div>
      </div>
      <slot name="content_after"></slot>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
import screen_mix from '@/mixins/screen_mix'
import SimpleTabs from '@/components/AppBar/SimpleTabs'

export default {
  name: 'TabsContentTemplate',
  components: {
    SimpleTabs,
  },
  mixins: [screen_mix],
  props: {
    editableName: Boolean,
    sections: {
      default: () => [
        {
          id: 'game',
          title: this.$t('common.board'),
          icon: 'mdi-cards-spade-outline',
          props: { tour: 'tra_advc_game' },
        },
      ],
    },
    tab: String,
  },
  emits: ['update:tab'],
  data() {
    return {
      l_tab: 'game',
    }
  },
  created() {},
  methods: {
    handleTabChange(val) {
      this.l_tab = val
      this.$emit('update:tab', val)
    },
    setTab() {
      this.l_tab = this.tab || this.sections[0].id
    },
  },
  computed: {
    tabItem() {
      return this.sections.find(i => i.id === this.l_tab) || {}
    },
  },
  watch: {
    tab: {
      immediate: true,
      handler: 'setTab',
    },
  },
}
</script>
<style lang="scss" scoped>
.tabscctmp {
  --right-display: flex;
  --min-width-right: 0px;
  --padding-content: 0px;
  --max-content-width: 100vw;
  --min-content-width: unset;

  // --right_oveflow-y: auto;
  // --right-oveflow-x: auto;
  --right-oveflow-x: hidden;
  --right-oveflow-y: auto;

  --content-direction: column;
  // --content-direction: row;
  --z-index-title: 4;
  --z-index-content: 1;

  display: grid;
  grid-template-columns: min-content auto;

  flex: 1;
  min-height: 0;
  &_left {
    border-right: 1px solid var(--clr-black-3);
    min-height: 0;
    max-width: 16rem;
    flex-shrink: 0;
    z-index: 1;
  }
  &_right {
    z-index: 2;
    flex-shrink: 0;
    display: flex;
    flex: 1;
    transition: 0.22s;
    overflow-y: var(--right-oveflow-y);
    overflow-x: var(--right-oveflow-x);
    // max-width: 100%;
    // min-height: 0; // left border-disapeared when this was here
    &_item-container {
      display: flex;
      flex: 1;
      // max-width: 100%;
    }
    &_item {
      &_title {
        font-size: 1rem;
        text-transform: uppercase;
        color: var(--clr-grey-2);
        padding: 0 1rem;
        height: 2.5rem;
        background: var(--clr-black-2);
        font-weight: 500;
        align-items: center;
        z-index: var(--z-index-title);
        position: sticky;
        top: -1px;
        left: 0;
        display: none;
      }
      &_content {
        padding: var(--padding-content);
        min-height: 0;
        flex: 1;
        position: relative;
        z-index: var(--z-index-content);
        display: flex;
        flex-direction: var(--content-direction);
        max-width: var(--max-content-width);
        min-width: var(--min-content-width);
        // &:hover {
        // z-index: 5;
        // }
      }
    }
  }
}

@media (max-width: 1023px) {
  .tabscctmp {
    // max-width: 100vw;
    display: flex;
    &_right_item-container {
      height: unset;
      flex-direction: column;
    }
    &_right {
      --right-oveflow-x: auto;
      --right-oveflow-y: auto;
      flex-direction: column;
      &_item {
        &_title {
          display: flex;
        }
        // &_content {
        // }
      }
    }
  }
}
</style>
